import { CommonModule } from '@angular/common'
import { BrowserModule } from '@angular/platform-browser'
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import {
  FeaturesConfigModule,
  I18nModule,
  UrlModule,
  ConfigModule,
  provideConfig,
  provideDefaultConfig,
} from '@spartacus/core'
import { CartItemListComponent } from './cart-item-list/cart-item-list.component'
import { CartItemComponent } from './cart-item/cart-item.component'
import { OrderSummaryComponent } from './order-summary/order-summary.component'
import {
  ItemCounterModule,
  MediaModule,
  SpinnerModule,
  DIALOG_TYPE,
} from '@spartacus/storefront'
import { OrderActionsComponent } from './order-actions/order-actions.component'
import { MatExpansionModule } from '@angular/material/expansion'
import { EmptyCartComponent } from './empty-cart/empty-cart.component'
import { DeleteBuyCartDialogComponent } from './cart-delete-dialog/cart-delete-dialog'
import { DeliveryGroupDialogComponent } from './cart-delivery-group-dialog/cart-delivery-group-dialog'
import { CompleteOrderDialogComponent } from './complete-order-dialog/complete-order-dialog'
import { MergeCartItemDialogComponent } from './merge-cart-item-dialog/merge-cart-item-dialog'
import { MinOrderConfirmationDialogComponent } from './min-order-dialog/min-order-dialog'
import { MatTooltipModule } from '@angular/material/tooltip'
import { NgSelectModule } from '@ng-select/ng-select'
import { CustomProductRoutesModule } from '../../config/product-routes.module'
import { ViewInventoryDialogComponent } from './view-inventory-dialog/view-inventory-dialog.component'
import { NonSellableDialogComponent } from './non-sellable-dialog/non-sellable-dialog'
import { QuantityCounterModule } from '../../../shared/components/quantity-counter'
import { DatePickerModule } from '../../../shared/components/date-picker/date-picker.module'
import { SpinnerOverlayModule } from '../../../shared/components/spinner-overlay/spinner-overlay.module'
import { environment } from '../../../../environments/environment'
import { VS_LAUNCH_CALLER } from '../../config/dialog.config';
import { CustomerReqDateDialogComponent } from './customer-req-date-dialog/customer-req-date-dialog.component'
import { MergeCartsCheckoutDialogComponent } from './merge-carts-checkout-dialog/merge-carts-checkout-dialog'

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    UrlModule,
    NgbModule,
    I18nModule,
    MediaModule,
    ItemCounterModule,
    FeaturesConfigModule,
    MatExpansionModule,
    QuantityCounterModule,
    DatePickerModule,
    SpinnerModule,
    SpinnerOverlayModule,
    MatTooltipModule,
    NgSelectModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['savedCart'],
        },
      },
    }),
    CustomProductRoutesModule,
  ],
  declarations: [
    CartItemComponent,
    OrderSummaryComponent,
    CartItemListComponent,
    OrderActionsComponent,
    EmptyCartComponent,
    DeleteBuyCartDialogComponent,
    DeliveryGroupDialogComponent,
    CompleteOrderDialogComponent,
    MergeCartItemDialogComponent,
    MinOrderConfirmationDialogComponent,
    ViewInventoryDialogComponent,
    NonSellableDialogComponent,
    CustomerReqDateDialogComponent,
    MergeCartsCheckoutDialogComponent,
  ],
  exports: [
    CartItemComponent,
    CartItemListComponent,
    OrderSummaryComponent,
    OrderActionsComponent,
    EmptyCartComponent,
    DeleteBuyCartDialogComponent,
    DeliveryGroupDialogComponent,
    CompleteOrderDialogComponent,
    MergeCartItemDialogComponent,
    MinOrderConfirmationDialogComponent,
  ],
  providers: [
    provideDefaultConfig({
      launch: {
        DELIVERY_GROUP: {
          inline: true,
          component: DeliveryGroupDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.DELETE_BUY_CART]: {
          inlineRoot: true,
          component: DeleteBuyCartDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.COMPLETE_ORDER]: {
          inlineRoot: true,
          component: CompleteOrderDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.MERGE_CART_ITEM]: {
          inlineRoot: true,
          component: MergeCartItemDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.MIN_ORDER_CONFIRMATION]: {
          inlineRoot: true,
          component: MinOrderConfirmationDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.VIEW_INVENTORY]: {
          inlineRoot: true,
          component: ViewInventoryDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.NON_SELLABLE]: {
          inlineRoot: true,
          component: NonSellableDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.CRD_INPUT_MODAL]: {
          inlineRoot: true,
          component: CustomerReqDateDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.MERGE_CHEKOUT_CART_ITEMS]: {
          inlineRoot: true,
          component: MergeCartsCheckoutDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        }
      },
    }),
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class CartSharedModule {}
